import { render, staticRenderFns } from "./single-invite.vue?vue&type=template&id=289c59cf&"
import script from "./single-invite.vue?vue&type=script&lang=js&"
export * from "./single-invite.vue?vue&type=script&lang=js&"
import style0 from "./single-invite.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports